:host{box-sizing:border-box;flex:1 0 0;width:100%;height:100%;max-height:100%;overflow-y:auto;padding:5rem}.screen{height:auto}
/*# sourceMappingURL=second-screen.component-WQY7MDE2.css.map */
